import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SuperElement } from '../../internals/super/SuperElement';
import { dimmerStyle } from './Dimmer.styles';

@customElement('lr-dimmer')
export class Dimmer extends SuperElement {
    @property({ type: Boolean, reflect: true }) active = true;
    @property({ type: Boolean, reflect: true }) blurring = false;

    static styles = [SuperElement.styles, dimmerStyle];

    renderElement() {
        return html`
            <div>
                <slot></slot>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'lr-dimmer': Dimmer;
    }
}
